import React, {useState} from "react";
import chlogo from '../../assets/images/svulogo.webp';
import svmuicon from '../../assets/images/svmu-icon.png';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import { faClipboardUser, faSquarePollHorizontal, faHospitalUser, faChartSimple, faUsers, faStore,
  faUserTie, faUserGraduate, faGraduationCap, faFileWord,
  faLandmark, faImages, faCalendarWeek, faCircleQuestion
 } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from 'react-redux';

const Sidebar = () => {
  const [selectedindex, setselectedindex] = useState(0);
  const userdata = useSelector((store) => store.userReducer.userdata)
    var navdata = [
        // {name: 'Dashboard', icon: faChartSimple, activeicon: faChartSimple, route: 'admin/dashboard', access: ['superadmin', 'admin']},
        {name: 'Alumni Commitee', icon: faUserTie, activeicon: faUserTie, route: 'admin/alumni-commitee', access: ['superadmin', 'admin']},
        {name: 'Alumni Registration', icon: faUserGraduate, activeicon: faUserGraduate, route: 'admin/alumni-registration', access: ['superadmin', 'admin']},
        {name: 'Alumni Courses', icon: faGraduationCap, activeicon: faGraduationCap, route: 'admin/alumni-courses', access: ['superadmin', 'admin']},
        {name: 'IJCAP Journals', icon: faFileWord, activeicon: faFileWord, route: 'admin/ijcap-journals', access: ['superadmin', 'admin']},
        {name: 'IJCAP Society', icon: faLandmark, activeicon: faLandmark, route: 'admin/ijcap-society', access: ['superadmin', 'admin']},
        {name: 'Gallery', icon: faImages, activeicon: faImages, route: 'admin/gallery', access: ['superadmin', 'admin']},
        {name: 'Events', icon: faCalendarWeek, activeicon: faCalendarWeek, route: 'admin/events', access: ['superadmin', 'admin']},
        // {name: 'Enquiries', icon: faCircleQuestion, activeicon: faCircleQuestion, route: 'admin/enquiries', access: ['superadmin', 'admin']},
    ];
    const location = useLocation();
    console.log('location.pathname >>>', location.pathname);
    return (
        <div className="sidebarmaindiv">
            {/* <img src={mainlogo} className="sidebarlogo" /> */}
            <img src={svmuicon} className="sidebarlogo" />
            <div className="sidebarnavmaindiv">
                {navdata?.map((item, index) => {
                  if(item?.access?.includes(userdata?.type)) {
                    var mainclass = "sidebarnavrow";
                    var iconname = item?.icon;
                    if(location.pathname == "/"+item.route) {
                        mainclass = "sidebarnavrow active";
                        iconname = item?.activeicon;
                    }
                    return (
                      <Link
                        to={"/" + item.route}
                        className={mainclass}
                        key={index}
                        onClick={() => {
                          setselectedindex(index);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.icon}
                        //   fontSize={19}
                          className="sidebarnavicon"
                          style={{
                            marginLeft: 15,
                            cursor: "pointer",
                          }}
                        />
                        <p className="shoppingtext">{item.name}</p>
                      </Link>
                    );
                  }
                   
                })}
                
            </div>
        </div>
    )
}

export default Sidebar